import httpMixin from "@/v2/mixins/http.js";
import { ProductGroupFactory, ProductGroupMapperParameter } from "@/v2/models/product-groups";
import mapperMixin from "@/v2/mixins/mapper.js";

export default {
    mixins: [httpMixin, mapperMixin],
    computed: {
        productGroupsUrl: {
            get() {
                return window.bo.productGroupsUrl;
            },
        },
    },
    methods: {
        _productGroupMapper(productGroup) {
            return {
                id: productGroup.id,
                name: productGroup.name,
                slug: productGroup.slug,
                count: productGroup.count,
                bo_can_delete: true,
                show_action_menu: true,
            };
        },

        parseProductGroup(productGroup) {
            return ProductGroupFactory.construct(
                this.createMapperParameter(new ProductGroupMapperParameter()),
                productGroup
            );
        },

        parseProductGroups(productGroups) {
            let parsedProductGroups = [];

            productGroups.forEach((productGroupData) => {
                const productGroup = this.parseProductGroup(productGroupData);
                parsedProductGroups.push(productGroup);
            });

            return parsedProductGroups;
        },

        getProductGroups(payload, success, failure) {
            return this.getData(
                this.productGroupsUrl,
                payload,
                (response) => {
                    success(this.parseProductGroups(response.data.data), response.data.meta);
                },
                failure
            );
        },
    },
};
